import { useParams } from "react-router-dom";
import { ACTIVE_LANG } from "App.constants";

export const useIsBeginner = () => {
  const { course } = useParams();
  return course?.includes("A0") || course?.includes("A1") || course?.includes("Welcome") || ACTIVE_LANG.short === "de";
};
